import { render } from "./Landing.vue?vue&type=template&id=a74ea36e"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=a74ea36e&lang=css"
script.render = render

export default script